export enum SEVERITY {
  HIGH = 1,
  MEDIUM = 2,
  LOW = 3,
}

export interface RowData {
  label: string | null;
  date?: string | null;
  value: string | SeverityData | null;
}

export interface SeverityData {
  severity: SEVERITY;
  percentage: number;
}

export enum FilterType {
  NONE,
  PORT,
  CVES,
  FINDING_NAME,
  PROTOCOL,
  VULNERABLE_TO_ZONE_TRANSFER,
  FINDING_TYPE,
  COUNTRY,
  EXPIRATION_STATUS,
  RECORD_TYPE,
  ASSET_STATUS,
  ASSET_RELATED_TO_ASSET,
  ARTIFACTS_RELATED_TO_ASSET,
  ASSETS_RELATED_TO_ARTIFACT,
}
